export default __webpack_public_path__ + "static/media/folder.6f7689bb.png";